<template>
  <div>
    <nav class="breadcrumb">
      <ul>
        <li><a @click.prevent="handleBreadcumb0()">Cart</a></li>
        <li><a @click.prevent="handleBreadcumb1()">Location</a></li>
        <li><a @click.prevent="handleBreadcumb2()">Delivery</a></li>
        <li>
          <a @click.prevent="handleBreadcumb3()" class="active">Payment</a>
        </li>
      </ul>
    </nav>

    <main class="payment-info">
      <div class="main-left">
        <div class="payment">
          <div class="payment-slip">
            <div class="payment-slip-top">
              <p class="title">Khaanpin 24 Hour Food Delivery</p>
            </div>
            <div class="payment-slipcode">
              <ul>
                <li class="order-id"></li>
                <li>Date & Time: {{ currentDateTime() }}</li>
              </ul>
              <ul class="loc">
                <!-- <li>Location: Kathmandu</li> -->
              </ul>
            </div>
            <div class="payment-slip-items">
              <ul>
                <li>Item</li>
                <li>Price</li>
                <li>Qty</li>
                <li>Total</li>
              </ul>
              <hr />
              <ul class="items" v-for="item in cartItems" :key="item.id">
                <li>{{ item.name }}</li>
                <li>NRs. {{ item.after_price }}</li>
                <li>{{ item.quantity }}</li>
                <li>NRs. {{ item.after_price * item.quantity }}</li>
              </ul>
              <hr />
            </div>

            <div class="payment-slip-calculation">
              <ul class="calculations total__calculations">
                <li>Subtotal</li>
                <li>NRs. {{ cartTotal }}</li>
              </ul>

              <!-- <ul
                class="category-price-container calculations"
                v-if="this.getPromoInfo.status === true"
              >
                <li class="category-text">Discount:</li>
                <div>
                  <li class="category-price">
                    NRs. {{ this.cartTotal - this.getPromoDiscountTotal }}
                  </li>
                </div>
              </ul>

              <ul
                class="category-price-container calculations"
                v-if="this.vat !== 0"
              >
                <li class="category-text">VAT(13%):</li>
                <li class="category-price">NRs. {{ this.vat }}</li>
              </ul>

              <ul
                class="category-price-container calculations"
                v-if="this.intlTransfer !== 0"
              >
                <li class="category-text">
                  International Transfer Charge(5.1%):
                </li>
                <li class="category-price">NRs. {{ this.intlTransfer }}</li>
              </ul> -->

              <ul
                class="category-price-container calculations"
                v-if="
                  this.promoInfo.status === true &&
                  this.getPromoDiscountTotal !== 0
                "
              >
                <li class="category-text">Discount:</li>
                <div>
                  <li class="category-price">
                    NRs. {{ this.cartTotal - this.getPromoDiscountTotal }}
                  </li>
                </div>
              </ul>

              <!-- <ul class="calculations">
                <li>Delivery Charge</li>
                <li>NRs. {{ deliveryCharge }}</li>
              </ul> -->

              <!-- <ul
                class="category-price-container calculations"
                v-if="this.vat !== 0"
              >
                <li class="category-text">VAT:</li>
                <li class="category-price">NRs. {{ this.vat }}</li>
              </ul>

              <ul
                class="category-price-container calculations"
                v-if="this.intlTransfer !== 0"
              >
                <li class="category-text">
                  International Transfer Charge:
                </li>
                <li class="category-price">NRs. {{ this.intlTransfer }}</li>
              </ul> -->

              <!-- <div class="total-price-container calculations">
                <p class="category-text">Total Amount:</p>
                <p class="total-price">
                  NRs.
                  {{
                    (this.getPromoDiscountTotal === 0
                      ? this.cartTotal
                      : this.getPromoDiscountTotal) +
                      this.deliveryCharge +
                      this.vat +
                      this.intlTransfer
                  }}
                </p>
              </div> -->
            </div>

            <div class="payment-slip-bottom">
              <ul>
                <li>You will get a confirmation call soon.</li>
                <span>
                  For enquires:
                  <br />
                  <span>Call us at +977-015970770 (Kathmandu)</span>
                  <br />

                  <span>Call us at +977-015970880/9802838383 (Pokhara)</span>
                </span>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="main-right">
        <div class="order-summary">
          <p class="title">Order Summary</p>
          <div class="calculations">
            <!-- <p>Subtotal ({{ cartQuantity }} items)</p> -->
            <p>Subtotal</p>
            <p>NRs. {{ cartTotal }}</p>
          </div>

          <div class="calculations">
            <p class="calculations__extra">++ Extra Charges</p>

            <div
              class="calculations__details"
              @click="showDropdown = !showDropdown"
            >
              <!-- <font-awesome-icon color="white" icon="caret-down" /> -->
              <a-icon type="caret-down" class="caret-down-icon" />
            </div>
          </div>

          <div v-if="showDropdown">
            <div class="calculations">
              <p>Delivery Charge</p>
              <p>NRs. {{ deliveryCharge }}</p>
            </div>

            <div
              class="category-price-container calculations"
              v-if="this.vat !== 0"
            >
              <p class="category-text">VAT:</p>
              <p class="category-price">NRs. {{ this.vat }}</p>
            </div>

            <div
              class="category-price-container calculations"
              v-if="this.intlTransfer !== 0"
            >
              <p class="category-text">International Transfer Charge:</p>
              <p class="category-price">NRs. {{ this.intlTransfer }}</p>
            </div>
          </div>

          <!-- <div class="calculations">
            <p>Delivery Charge</p>
            <p>NRs. {{ deliveryCharge }}</p>
          </div> -->

          <!-- <button class="discount">
            <div class="discount-details-wrapper">
              <div class="discounts-info">
                <span
                  v-if="
                    this.getPromoInfo.description ||
                    this.getPromoInfo.cookedFood ||
                    this.getPromoInfo.mart ||
                    this.getPromoInfo.bakery ||
                    this.getPromoInfo.liquor ||
                    this.getPromoInfo.deliveryCharge
                  "
                  class="discounts-header"
                  >Coupon Discount Applied!</span
                >
                <span v-if="this.getPromoInfo.description">
                  {{ this.getPromoInfo.description }}
                </span>
                <span v-if="this.getPromoInfo.cookedFood > 0">
                  {{ this.getPromoInfo.cookedFood }}% Discount in Food Items.
                </span>
                <span v-if="this.getPromoInfo.mart > 0">
                  {{ this.getPromoInfo.mart }}% Discount in Mart Items.
                </span>
                <span v-if="this.getPromoInfo.bakery > 0">
                  {{ this.getPromoInfo.bakery }}% Discount in Bakery Items.
                </span>
                <span v-if="this.getPromoInfo.liquor > 0">
                  {{ this.getPromoInfo.liquor }}% Discount in Liquor Items.
                </span>
                <span v-if="this.getPromoInfo.deliveryCharge >= 0"
                  >Delivery Charge Rs
                  {{ this.getPromoInfo.deliveryCharge }}.</span
                >
              </div>
            </div>
          </button> -->

          <div class="coupon-code">
            <button class="promo-button" @click="handleCouponForm">
              I Have a Discount Coupon <a-icon type="gift" class="gift-icon" />
            </button>
            <div v-if="showCouponForm">
              <form
                class="promo-form"
                v-if="!this.promoInfo.status"
                @submit="sendPromo"
              >
                <input
                  class="promo-input"
                  type="varchar"
                  placeholder="Enter Coupon"
                  name="coupon"
                  id="coupon"
                  v-model="coupon"
                />
                <input class="promo-submit-btn" type="submit" value="Apply" />
              </form>

              <div v-else class="discount-details-wrapper">
                <form class="promo-form" @submit="sendPromo">
                  <input
                    class="promo-input"
                    type="varchar"
                    placeholder="Enter Coupon"
                    name="coupon"
                    id="coupon"
                    v-model="coupon"
                  />
                  <input class="promo-submit-btn" type="submit" value="Apply" />
                </form>
                <div class="discounts">
                  <span class="discounts-header">Coupon Discount Applied!</span>
                  <div class="discounts-info">
                    <span v-if="this.promoInfo.description">
                      {{ this.promoInfo.description }}
                    </span>
                    <span v-if="this.promoInfo.cookedFood > 0">
                      {{ this.promoInfo.cookedFood }}% Discount in Food Items.
                    </span>
                    <span v-if="this.promoInfo.mart > 0">
                      {{ this.promoInfo.mart }}% Discount in Mart Items.
                    </span>
                    <span v-if="this.promoInfo.bakery > 0">
                      {{ this.promoInfo.bakery }}% Discount in Bakery Items.
                    </span>
                    <span v-if="this.promoInfo.liquor > 0">
                      {{ this.promoInfo.liquor }}% Discount in Liquor Items.
                    </span>
                    <span v-if="this.promoInfo.deliveryCharge >= 0"
                      >Delivery Charge Rs
                      {{ this.promoInfo.deliveryCharge }}.</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="category-price-container calculations"
            v-if="this.getPromoStatus === true"
          >
            <p class="category-text">Discount:</p>
            <!-- <span>{{ this.cartTotal }}</span>
            <br />
            <span>{{ this.getPromoDiscountTotal }}</span>
            <br />
            <span>{{ this.newTotal }}</span> -->
            <p class="category-price">
              NRs. {{ this.cartTotal - this.getPromoDiscountTotal }}
            </p>
          </div>

          <!-- <div>
            <div class="calculations">
              <p>Delivery Charge</p>
              <p>NRs. {{ deliveryCharge }}</p>
            </div>

            <div
              class="category-price-container calculations"
              v-if="this.vat !== 0"
            >
              <p class="category-text">VAT(13%):</p>
              <p class="category-price">NRs. {{ this.vat }}</p>
            </div>

            <div
              class="category-price-container calculations"
              v-if="this.intlTransfer !== 0"
            >
              <p class="category-text">International Transfer Charge(5.1%):</p>
              <p class="category-price">NRs. {{ this.intlTransfer }}</p>
            </div>
          </div> -->

          <div class="total-price-container calculations">
            <p class="category-text">Total Amount:</p>
            <p class="">
              NRs.
              {{
                (this.getPromoDiscountTotal === 0
                  ? this.cartTotal
                  : this.getPromoDiscountTotal) +
                this.deliveryCharge +
                this.vat +
                this.intlTransfer
              }}
            </p>
          </div>
        </div>

        <div class="payment-option">
          <p class="title">Payment Options</p>
          <a-radio-group
            v-if="!this.gotLocationError"
            v-model="paymentCode"
            class="payment-options"
            @change="handlePaymentMode"
          >
            <a-radio :value="6" class="radio-options">
              <img
                src="../../../assets/imepaylogo.svg"
                class="client_image"
                alt="IMEPay"
              />
            </a-radio>
            <a-radio :value="1" class="radio-options">
              <img
                src="../../../assets/images/image_5.svg"
                class="client_image"
                alt="eSewa"
              />
            </a-radio>
            <a-radio :value="2" class="radio-options">
              <img
                src="../../../assets/images/image_6.svg"
                class="client_image"
                alt="Card Payment"
              />
            </a-radio>
            <a-radio :value="4" class="radio-options">
              <img
                src="../../../assets/images/fonepay_logo.jpg"
                class="client_image"
                alt="Fonepay"
              />
            </a-radio>
            <a-radio :value="3" class="radio-options">
              <img
                src="../../../assets/images/cod.svg"
                class="client_image"
                alt="Cash On Delivery"
              />
            </a-radio>
            <a-radio :value="5" class="radio-options">
              <img
                src="../../../assets/images/bt.svg"
                class="client_image"
                alt="Bank Transfer"
              />
            </a-radio>
          </a-radio-group>

          <a-radio-group
            v-if="this.gotLocationError"
            v-model="paymentCode"
            class="payment-options"
            @change="handlePaymentMode"
          >
            <a-radio :value="3" class="radio-options">
              <img
                src="../../../assets/images/cod.svg"
                class="client_image"
                alt="Cash On Delivery"
              />
            </a-radio>
          </a-radio-group>
        </div>

        <div class="buttons">
          <a>
            <button
              @click.prevent="handleContinueShopping()"
              :disabled="orderSubmitted"
            >
              <a-icon type="shopping-cart" />ADD MORE ITEMS
            </button>
          </a>
          <a>
            <button @click.prevent="confirmOrder()" :disabled="orderSubmitted">
              CONFIRM ORDER
            </button>
          </a>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { LocationId, CartData } from "../../../services/storage.service";
import { UserService } from "../../../services/user.service";
import router from "../../../router";
import { format } from "date-fns";

import WizardFooter from "../../../components/FloatingFooter/WizardFooter";

export default {
  name: "PaymentForm",
  components: {
    WizardFooter,
  },
  data() {
    return {
      isSubmitted: false,
      showDropdown: false,
      loading: true,
      cartQuantity: 0,
      paymentCode: "",
      delCharge: 0,
      gotError: true,
      gotLocationError: true,
      errorMessage: "",
      orderSubmitted: false,
      // oId: CartData.getOrderId(),
      orderFailed: false,
      intlTransfer: 0,
      vat: 0,
      promoInfo: {
        status: false,
        description: "",
        deliveryCharge: "",
        cookedFood: "",
        mart: "",
        bakery: "",
        liquor: "",
      },
      coupon: "",
      showCouponForm: false,
      // cartItems: CartData.getCartItems(),
      allItems: [],
      newTotal: 0,
      orderID: CartData.getOrderId(),
    };
  },
  watch: {
    getPromoStatus: function (val) {
      this.getCartItemsCategories();
    },

    getOrderError: function (val) {
      if (val === "" || undefined) {
        return;
      } else {
        this.orderFailed = true;
        this.$notification.error({
          message: "Error",
          description: "Error while ordering food.",
        });
        setTimeout(this.clearOrderError, 3000);
      }
    },
    cartItems: function (val) {
      let quantity = val.reduce((acc, item) => acc + item.quantity, 0);
      this.cartQuantity = quantity;
    },
  },
  computed: {
    ...mapGetters([
      "locationMarker",
      "cartTotal",
      "cartItems",
      "payMode",
      "getOrderError",
      "getIntlTransferCharge",
      "getVAT",
      "getPromoDiscountTotal",
      "deliveryCharge",
      "getPromoInfo",
      "getPromoStatus",
      "totalPrice",
    ]),

    getCartItemsCategories() {
      // e.preventDefault();

      // cart items
      const cData = CartData.getCartItems();

      // adding item section
      let cartCat = cData.map((obj) => {
        const index = this.allItems.findIndex((el) => el["id"] == obj["id"]);
        const { section } = index !== 1 ? this.allItems[index] : {};

        return {
          ...obj,
          section,
        };
      });

      // group items according to category
      const groupCategories = cartCat.reduce((acc, cV) => {
        acc[cV.section] = acc[cV.section] || [];
        acc[cV.section].push(cV);

        return acc;
      }, Object.create(null));

      // console.log("groupCategories", groupCategories);

      // calculate category total
      let totalObj = this.getCatTotal(groupCategories);
      // console.log("totalObj: " + JSON.stringify(totalObj));

      // adding category discount %
      let discountObj = this.createDiscountObj();
      // console.log("discountObj: " + JSON.stringify(discountObj));

      // merging two datasets
      let mergedObj = totalObj.map((item) => ({
        ...item,
        ...discountObj.find((innerItem) => innerItem.cat === item.cat),
      }));
      // console.log("merge Obj: " + JSON.stringify(mergedObj));

      /* calculate cart total
        returns total if dis is empty
        returns discounted total if dis available
      */
      const catTotal = mergedObj.reduce(
        (sum, { cat_total, dis }) => sum + this.calcCatDiscount(cat_total, dis),
        0
      );
      // console.log("catTotal: " + catTotal);

      this.newTotal = catTotal;
      this.addDiscount(catTotal);
    },
  },
  created() {
    window.scrollTo(0, 0);

    let quantity = this.cartItems.reduce((acc, item) => acc + item.quantity, 0);
    this.cartQuantity = quantity;
  },
  methods: {
    ...mapActions([
      "submitOrder",
      "updateStep",
      "updateMode",
      "clearOrderError",
      "updatePayment",
      "applyITC",
      "applyVAT",
      "applyDeliveryCharge",
      "addDiscount",
      "addCFDiscount",
      "addMDiscount",
      "addBDiscount",
      "addLDiscount",
      "addPromoCode",
      "setPromoInfo",
      "setPromoStatus",
    ]),

    calculateTotalAmount() {
      let totalAmount =
        (this.getPromoDiscountTotal === 0
          ? this.cartTotal
          : this.getPromoDiscountTotal) +
        this.deliveryCharge +
        this.vat +
        this.getIntlTransferCharge;

      CartData.setCartAmount(totalAmount);
    },

    currentDateTime() {
      const currentDate = new Date();

      const date = format(currentDate, "MM-dd-yyyy");
      const time = format(currentDate, "hh:mm");

      const dateTime = `${date} ${time}`;

      return dateTime;
    },

    getDeliveryCharge() {
      // const url = "https://manager.khaanpin.com/apiv2/getdeliverycharge/";
      const url = "https://deus.khaanpin.com/appapi/getdeliverycharge/";

      axios
        .post(url, {
          loc_id: LocationId.getLocationId(),
          location: "https://www.google.com/maps/place/" + this.locationMarker,
        })
        .then((response) => {
          if (response.data.error === true) {
            this.gotLocationError = true;
            this.errorMessage = response.data.data;
            this.loading = false;
          } else {
            this.gotLocationError = false;
            CartData.setDeliveryCharge(response.data.data);
            this.applyDeliveryCharge(response.data.data);
            this.delCharge = response.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.gotError = true;
          this.loading = false;
        });
    },

    confirmOrder() {
      // if (!this.paymentCode === "") {
      //   this.isSubmitted = true;
      // }
      this.calculateTotalAmount();
      CartData.removeOrderId();
      CartData.removeCartTotal();

      if (this.paymentCode === "") {
        this.$notification.error({
          message: "Please Select a Payment Method",
          description:
            "Select your preferred payment method before placing order!",
        });
      } else {
        this.orderSubmitted = true;

        this.submitOrder({
          paymentCode: this.paymentCode,
        });

        CartData.removeOrderId();
      }
    },

    handleFailedOrder() {
      this.updateStep(0);
      CartData.removeDeliveryCharge();
      CartData.removeOrderId();
      CartData.removeCartTotal();
    },

    handlePaymentMode(e) {
      if (e.target.value == 1) {
        this.paymentCode = 1;
        this.updateMode(1);
        this.updatePayment("Esewa");
      } else if (e.target.value == 2) {
        this.paymentCode = 2;
        this.updateMode(2);
        this.updatePayment("Card");
      } else if (e.target.value == 3) {
        this.paymentCode = 3;
        this.updateMode(3);
        this.updatePayment("Cash");
      } else if (e.target.value == 4) {
        this.paymentCode = 4;
        this.updateMode(4);
        this.updatePayment("Fonepay");
      } else if (e.target.value == 5) {
        this.paymentCode = 5;
        this.updateMode(5);
        this.updatePayment("Bank Transfer");
      } else if (e.target.value == 6) {
        this.paymentCode = 6;
        this.updateMode(6);
        this.updatePayment("IMEPay");
      }
    },

    getUserTimezone() {
      const timezone = new Date().getTimezoneOffset();

      if (timezone !== -345) {
        this.intlTransfer = Math.ceil((5.1 / 100) * this.cartTotal);
        this.applyITC(Math.ceil((5.1 / 100) * this.cartTotal));
        this.vat = Math.ceil((13 / 100) * this.cartTotal);
        this.applyVAT(Math.ceil((13 / 100) * this.cartTotal));
      } else {
        this.intlTransfer = 0;
        this.applyITC(0);
        this.vat = 0;
        this.applyVAT(0);
      }
    },

    getUserRegion() {
      axios
        .get("https://ipinfo.io/json", {
          params: { token: "99e1724e05bca0" },
        })
        .then((response) => {
          if (response.data.country === "NP") {
            this.intlTransfer = 0;
            this.applyITC(0);
            this.vat = 0;
            this.applyVAT(0);
          } else {
            this.intlTransfer = Math.ceil((5.1 / 100) * this.cartTotal);
            this.applyITC(Math.ceil((5.1 / 100) * this.cartTotal));
            this.vat = Math.ceil((13 / 100) * this.cartTotal);
            this.applyVAT(Math.ceil((13 / 100) * this.cartTotal));
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    handleCouponForm() {
      this.showCouponForm = !this.showCouponForm;
    },

    sendPromo(e) {
      e.preventDefault();

      this.addPromoCode(this.coupon);

      UserService.promoSend(this.coupon)
        .then((data) => {
          const DATA = data.data;

          if (DATA.status === true) {
            this.promoInfo.status = true;
            this.promoInfo.description = DATA.description;

            this.promoInfo.deliveryCharge = DATA.delivery_charge;

            this.promoInfo.cookedFood = DATA.cooked_food;
            this.promoInfo.mart = DATA.mart;
            this.promoInfo.bakery = DATA.bakery;
            this.promoInfo.liquor = DATA.liquor;

            // this.addDiscount(0);
            this.addCFDiscount(DATA.cooked_food);
            this.addMDiscount(DATA.mart);
            this.addBDiscount(DATA.bakery);
            this.addLDiscount(DATA.liquor);
            this.setPromoStatus(true);

            // console.log("delvery charge: " + DATA.delivery_charge);
            // console.log("add CF Discount: " + DATA.cooked_food);
            // console.log("add MD Discount: " + DATA.mart);
            // console.log("add BD Discount: " + DATA.bakery);
            // console.log("add LD Discount: " + DATA.liquor);

            if (DATA.delivery_charge >= 0) {
              CartData.setDeliveryCharge(DATA.delivery_charge);
              this.applyDeliveryCharge(DATA.delivery_charge);
              this.delCharge = DATA.delivery_charge;
            }

            // this.getCartItemsCategories(e);
          } else {
            this.$notification.error({
              message: "Promo Code is not valid",
              description: "Please confirm your promo code as it is not valid.",
            });
          }
        })
        .catch((err) => console.log(err));
    },

    async getItems() {
      let allData = [];
      let morePagesAvailable = true;
      let currentPage = 0;

      while (morePagesAvailable) {
        currentPage++;
        const response = await axios.post(
          "https://deus.khaanpin.com/om/getitemsv2/",
          {
            loc_id: LocationId.getLocationId(),
            page: currentPage,
          }
        );

        let { data, page_count } = response.data;
        data.forEach((e) => allData.push(e));
        morePagesAvailable = currentPage < page_count;
      }

      const result = allData.map((data) => ({
        id: data.id,
        section: data.section,
      }));

      this.allItems = result;
    },

    getCatTotal(array) {
      let newData = [];

      Object.entries(array).forEach((entry) => {
        const [key, value] = entry;
        let cat_total = this.calcCatTotal(value);

        newData.push({ cat: key, cat_total });
      });

      return newData;
    },

    calcCatTotal(array) {
      const categoryTotal = array.reduce(
        (sum, { after_price, quantity }) => sum + after_price * quantity,
        0
      );
      return categoryTotal;
    },

    createDiscountObj() {
      let disObj = [];

      disObj.push(
        { cat: "cooked-food", dis: this.promoInfo.cookedFood },
        { cat: "mart", dis: this.promoInfo.mart },
        { cat: "bakery", dis: this.promoInfo.bakery },
        { cat: "drinks", dis: this.promoInfo.liquor }
      );

      return disObj;
    },

    calcCatDiscount(total, discount) {
      // console.log(total, discount);
      const discountedPrice = Math.ceil(total - (discount / 100) * total);
      // console.log(discountedPrice);
      return discountedPrice;
    },

    handleContinueShopping() {
      router.push("/:loc?");
    },

    handleCheckout() {
      // alert('clicked');
      if (this.cartTotal < 500) {
        this.$message.warning(`"Cart should be atleast of NRs. 500."`);
      } else {
        this.updateStep(4);
      }
    },
    handleBreadcumb0() {
      this.updateStep(0);
      // this.setPromoInfo(this.promoInfo);

      // window.location.reload();
    },
    handleBreadcumb1() {
      this.updateStep(1);
    },
    handleBreadcumb2() {
      this.updateStep(2);
    },
    handleBreadcumb3() {
      this.updateStep(3);
    },
  },
  beforeMount() {
    // this.getUserRegion();
    this.getItems();
    this.getUserTimezone();
    this.getDeliveryCharge();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

// new css
// variables
$theme-color: #ed3c3b;
$font-color: #706b6b;
$detail-color: #333;
$success-color: #60b246;
$info-color: #2e89d3;

$button-size: 16px;
$text-size: 16px;
$icon-size: 20px;
$heading-size: 24px;
$display-size: 36px;

$border: 1px solid rgba(3, 3, 3, 0.3);
$border-radius: 10px;

nav {
  max-width: 60rem;
  margin: 0px auto 20px;
  ul {
    list-style: none;
    li {
      display: inline;
      + li:before {
        content: ">";
        padding: 10px;
      }
      a {
        text-decoration: none;
        color: $font-color;
        font-size: $icon-size;
        text-transform: uppercase;
        color: $font-color;
        padding: 5px 10px;
        &:hover {
          opacity: 0.8;
          transition: all ease-in-out 0.3s;
        }
      }
      .active {
        color: $theme-color;
        font-weight: bold;
      }
    }
  }
}
main {
  width: 60rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 0.6fr;
  grid-gap: 20px;
  hr {
    opacity: 0.3;
  }
  p {
    font-size: $text-size;
    color: $detail-color;
  }
  .main-left {
    .payment {
      border-radius: $border-radius;
      padding: 20px;
      width: auto;
      height: 550px;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      border-radius: $border-radius;
      padding: 20px;
      width: auto;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      overflow-y: scroll;
      .payment-slip {
        .payment-slip-top {
          display: flex;
          align-items: center;
          justify-content: center;
          .title {
            font-weight: bold;
            color: $detail-color;
            // margin-bottom: 20px;
            font-size: calc($text-size + 5px);
            margin-top: 10px;
            text-align: center;
          }
        }
        ul {
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          li {
            list-style-type: none;
          }
        }
        .payment-slipcode {
          ul {
            .order-id {
              font-size: $text-size;
              font-weight: bold;
            }
            &:last-child {
              justify-content: flex-end;
            }
          }
          .loc {
            // background-color: red;
            margin-top: -15px;
          }
        }
        .payment-slip-items {
          color: $detail-color;
          margin-top: 10px;
          ul {
            justify-content: flex-start;
            text-align: center;
            margin-bottom: 5px;
            font-weight: bold;
            li {
              &:nth-child(1) {
                flex-basis: 50%;
              }
              &:nth-child(2) {
                flex-basis: 20%;
              }
              &:nth-child(3) {
                flex-basis: 10%;
              }
              &:nth-child(4) {
                flex-basis: 20%;
              }
            }
          }
          .items {
            margin: 10px 0;
            font-weight: 500;
            font-size: 14px;
            li {
              &:first-child {
                text-align: left;
              }
            }
          }
        }
        .payment-slip-calculation {
          color: $detail-color;
          margin-top: 5px;
          ul {
            font-size: 15px;
          }
        }
        .payment-slip-bottom {
          color: $detail-color;
          ul {
            color: $detail-color;
            display: inline-block;
            font-size: 12px;
            margin-top: 10px;
            span {
              color: $theme-color;
            }
          }
        }
      }
    }
  }
  .main-right {
    margin-bottom: 50px;

    .order-summary {
      border-radius: $border-radius;
      width: auto;
      padding: 20px 20px 8px;

      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      .title {
        font-size: $heading-size;
        color: $detail-color;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .items-list {
        height: 9rem;
        padding: 0 10px;
        margin-bottom: 10px;
        border: $border;
        border-radius: $border-radius;
        overflow-y: hidden;
        &:hover {
          overflow-y: scroll;
        }
        .item {
          display: flex;
          margin: 20px 0 10px;
          .item-left {
            img {
              height: 50px;
              width: 50px;
              border-radius: $border-radius;
              box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
            }
          }
          .item-right {
            margin-left: 20px;
            .item-name {
              font-size: $text-size;
              font-weight: bold;
            }
          }
        }
      }
      .calculations {
        display: flex;
        justify-content: space-between;
      }
      .calculations__extra {
        font-size: 14px;
        color: rgb(100, 100, 100);
        // font-weight: bolder;
      }

      .caret-down-icon {
        color: black;
        font-size: 12px;
      }

      .calculations__details {
        // border: 1px solid black;
        border-radius: 8px;
        height: 25px;
        width: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background: #c2c2c2;
      }
      .calculations__details:hover {
        background: #a2a2a2;
        transition: 0.5s all;
      }
      .discount {
        width: 100%;
        outline: none;
        border: none;
        color: $detail-color;
        margin-bottom: 10px;

        &:hover {
          cursor: default;
        }
        li {
          list-style: none;
        }
        span {
          display: block;
        }
        .discounts-header {
          padding: 10px 0;
          text-decoration: underline;
        }
        .discounts-info {
          // height: 0;
          // padding: 10px;
          // margin-bottom: 10px;
          font-size: $button-size;
          font-weight: bold;
          background-color: #ffff00;
        }
      }
      .coupon-code {
        margin-bottom: 10px;
        button {
          width: 100%;
        }
        form {
          // background-color: rebeccapurple;
          display: flex;
          justify-content: center;
          align-items: center;
          input[type="varchar"] {
            flex: 1 1 auto;
          }
          input[type="submit"] {
            padding: 0 20px;
          }
        }
        .promo-button {
          align-self: center;
          font-size: 16px;
          outline: none;
          color: #fff;
          border: none;
          cursor: pointer;
          padding: 5px 10px;
          border-radius: 5px;
          background-color: #1e90ff;
        }

        .promo-button:hover {
          box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
        }

        .promo-form {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: $main-font;
          margin-top: 10px;

          .promo-input {
            height: 32px;
            border-radius: 5px;
            border: 1px solid $text-color2;
            outline: none;
            padding-left: 5px;
            color: $text-color;
            margin-right: 5px;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            width: 30%;
          }

          .promo-input:hover {
            border: 1px solid #1e90ff;
          }

          .promo-submit-btn {
            text-align: center;
            height: 32px;
            width: 80px;
            padding: 0px 5px;
            border-radius: 5px;
            background-color: #1e90ff;
            border: 1px solid #1e90ff;
            color: #fff;
            cursor: pointer;
            font-size: 13px;
            outline: none;
          }

          .promo-submit-btn:hover {
            border: 1px solid gray;
            background-color: #fff;
            color: gray;
          }
        }
      }

      .discount-details-wrapper {
        margin: 5px 0 10px;
        text-align: center;
        color: $detail-color;
        // font-size: $button-size;
        .discounts {
          font-weight: bold;
          background-color: #ffff00;
          padding: 10px 0;
          margin-top: 5px;
          .discounts-header {
            // font-weight: bold;
            font-size: $button-size;
            text-decoration: underline;
          }
          .discounts-info {
            margin-top: 5px;

            span {
              display: block;
            }
          }
        }
      }
    }
    .payment-option {
      border-radius: $border-radius;
      padding: 20px;
      width: auto;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      margin-top: 20px;
      .title {
        font-size: $heading-size;
        color: $detail-color;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .options {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          height: 30px;
          width: 50px;
          background-color: rgba(179, 179, 179, 0.15);
        }
        input[type="radio"] {
          &:not(:first-child) {
            margin-left: 10px;
          }
        }
      }
      .payment-options {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 10px;
        // flex-wrap: wrap;
        .radio-options {
          img {
            height: auto;
            width: 90px;
            background-color: rgba(179, 179, 179, 0.15);
          }
        }
      }
    }
    .buttons {
      padding: 20px;
      margin-top: 20px;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      border-radius: $border-radius;
      display: flex;
      flex-flow: column nowrap;
      a {
        &:not(:last-child) {
          margin-bottom: 10px;
        }
        &:last-child {
          button {
            background-color: $success-color;
            color: #fff;
          }
        }
        button {
          padding: 10px;
          width: 100%;
          font-size: $button-size;
          border-radius: $border-radius;
          border: $border;
          outline: none;
          color: $font-color;
          background-color: white;
          box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
          i {
            font-size: 20px;
            margin-right: 5px;
          }
          &:hover {
            cursor: pointer;
            transition: all ease-in-out 0.3s;
            box-shadow: none;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1220px) {
  .breadcrumb {
    max-width: 50rem;
    margin: 0px auto 20px;
  }
  main {
    max-width: 50rem;
    .main-left {
      .payment {
        height: auto;
        max-height: 550px;
      }
    }
    .main-right {
      .payment-option {
        .payment-options {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 10px;
          // flex-wrap: wrap;
        }
      }
    }
  }
}
@media screen and (max-width: 1022px) {
  .breadcrumb {
    max-width: 35rem;
    margin: 0px auto 20px;
  }
  main {
    max-width: 35rem;
    grid-template-columns: 1fr;
    .main-right {
      .payment-option {
        .payment-options {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          grid-gap: 10px;
          // flex-wrap: wrap;
        }
      }
    }
  }
}

@media screen and (max-width: 720px) {
  .breadcrumb {
    ul {
      margin-left: 20px;
      li {
        + li:before {
          padding: 2px;
        }
        a {
          padding: 5px;
          font-size: calc(var(--icon-size) - 4px);
        }
      }
    }
  }
  main {
    width: 90vw;
    // border: 1px solid black;

    margin: 0 auto;
    .main-right {
      .payment-option {
        // border: 1px solid black;
        width: 90vw;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        // height: 300px;

        .payment-options {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 15px;

          // flex-wrap: wrap;
        }
      }
    }
  }
}

// old css
@mixin flexbox() {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-button-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 40px;
  .custom-button {
    height: 45px;
    font-size: 14px;
    border-radius: 4px;
    &.green {
      background: #60b246;
      border-color: #60b246;
      &:hover {
        background: #fff;
        border-color: gray;
      }
    }
    &.hide {
      display: none;
    }
  }

  .cancel-button {
    text-decoration: underline;
    color: #000;
    font-size: 12px;
    margin-top: 20px;
    cursor: pointer;
  }
}

.failed-order-div {
  @include flexbox();
  flex-direction: column;
  .tryagain-button {
    display: inline-block;
    padding: 10px;
    background-color: #ed2027;
    color: white;
    height: auto;
    cursor: pointer;
    font-family: "Poppins", sans-serif;
    text-transform: uppercase;
    border-radius: 4px;
    margin-top: 20px;
  }
}

.total__calculations {
  font-size: 18px;
  font-weight: 600;
}

.total-price-container {
  border-top: 1px solid gray;
  padding-top: 10px;
  margin-top: 10px;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .total-price {
    text-align: center;
    color: #60b246;
  }
}

.subtotal-wrapper {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  flex: 2.5;

  .category-price-container {
    margin-top: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .category-text {
      text-align: left;
    }

    .category-price {
      font-weight: 600;
      color: #60b246;
      margin-left: 10px;
    }

    .location-error {
      font-weight: 600;
      color: #ec3934;
      margin-left: 10px;
    }
  }

  .promo-wrapper {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
  }

  .gift-icon {
    font-size: 16px;
    margin-left: 5px;
  }

  .promo-button-wrapper {
    display: flex;
    align-self: flex-end;
  }

  .promo-button {
    align-self: center;
    font-size: 13px;
    outline: none;
    color: #fff;
    border: none;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 5px;
    background-color: #1e90ff;
  }

  .promo-button:hover {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }

  .promo-form {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: $main-font;
    margin-top: 10px;

    .promo-input {
      height: 32px;
      border-radius: 5px;
      border: 1px solid $text-color2;
      outline: none;
      padding-left: 5px;
      color: $text-color;
      margin-right: 5px;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      width: 30%;
    }

    .promo-input:hover {
      border: 1px solid #1e90ff;
    }

    .promo-submit-btn {
      text-align: center;
      height: 32px;
      padding: 0px 5px;
      border-radius: 5px;
      background-color: #1e90ff;
      border: 1px solid #1e90ff;
      color: #fff;
      cursor: pointer;
      font-size: 13px;
      outline: none;
    }

    .promo-submit-btn:hover {
      border: 1px solid gray;
      background-color: #fff;
      color: gray;
    }
  }

  .discount-details-wrapper {
    margin: 20px 0px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .discounts-header {
      color: #1e90ff;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }

    .discounts-info {
      margin: 5px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
    }
  }
}

@media only screen and (max-width: 740px) {
  .payment-container {
    min-width: 200px;
    overflow: visible;
    margin: 5px;
    padding: 20px;
  }

  .promo-wrapper {
    margin-top: 5px;
  }

  .gift-icon {
    font-size: 14px;
    margin-left: 5px;
  }

  .promo-input {
    width: 45% !important;
  }
}

//NEW

.payment-container {
  display: flex;
  justify-content: center;
  background-color: #f2f2f2;
  height: 450px;
  width: 100%;
  padding: 15px;
  font-family: $main-font;
  overflow-x: hidden;
  overflow-y: scroll;

  .loading-text {
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    align-self: center;
  }

  .order-submit-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .inner-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .message-wrapper {
      line-height: 22px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      .message-text {
        font-weight: 400;
        font-size: 12px;
        text-align: center;

        .delivery-charge {
          color: #60b264;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
  }
}

.payment-wrapper {
  padding-top: 10px;
  flex: 2.5;

  .pay-header {
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 16px;
  }

  /*  .payment-options {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    height: auto;

    .radio-options {
      margin: 10px 5px;
      font-size: 14px;
      font-weight: 500;
      text-align: center;

      .client_image {
        height: auto;
        width: 100px;
      }
    }
  } */
}

.buttons button:disabled {
  cursor: not-allowed !important;
  pointer-events: all !important;
}
</style>
